__turbopack_context__.v({
  "ManualNav": "i6pdMW_ManualNav",
  "ManualNav--Expanded": "i6pdMW_ManualNav--Expanded",
  "ManualNav__ChapterLink": "i6pdMW_ManualNav__ChapterLink",
  "ManualNav__ChapterRow": "i6pdMW_ManualNav__ChapterRow",
  "ManualNav__ChapterRow--Active": "i6pdMW_ManualNav__ChapterRow--Active",
  "ManualNav__Chapters": "i6pdMW_ManualNav__Chapters",
  "ManualNav__Container": "i6pdMW_ManualNav__Container",
  "ManualNav__Icon": "i6pdMW_ManualNav__Icon",
  "ManualNav__MatchCount": "i6pdMW_ManualNav__MatchCount",
  "ManualNav__MobileIcon": "i6pdMW_ManualNav__MobileIcon",
  "ManualNav__MobileTag": "i6pdMW_ManualNav__MobileTag",
  "ManualNav__MobileTitle": "i6pdMW_ManualNav__MobileTitle",
  "ManualNav__MobileToggle": "i6pdMW_ManualNav__MobileToggle",
  "ManualNav__SectionLink": "i6pdMW_ManualNav__SectionLink",
  "ManualNav__SectionLink--Active": "i6pdMW_ManualNav__SectionLink--Active",
  "ManualNav__Sections": "i6pdMW_ManualNav__Sections",
  "ManualNav__Sections--Expanded": "i6pdMW_ManualNav__Sections--Expanded",
  "ManualNav__SectionsInner": "i6pdMW_ManualNav__SectionsInner",
  "ManualNav__Toggle": "i6pdMW_ManualNav__Toggle",
  "ManualNav__Toggle--Expanded": "i6pdMW_ManualNav__Toggle--Expanded",
  "ManualNav__ToggleIcon": "i6pdMW_ManualNav__ToggleIcon",
  "ManualNav__ToggleSlot": "i6pdMW_ManualNav__ToggleSlot",
});
